import React, {forwardRef} from 'react';

import {BoxedInput, BoxedInputInheritableProps} from './boxedInput';
import {BoxedTextAreaElement, BoxedTextAreaElementInheritableProps} from './boxedTextAreaElement';

/*
 * Props.
 */

export type TextBoxProps = BoxedInputInheritableProps & BoxedTextAreaElementInheritableProps;

/*
 * Component.
 */

/** Basic textarea. */
export const TextAreaBox = forwardRef<BoxedInput, TextBoxProps>((props, ref) => (
  <BoxedInput {...props} ref={ref}>
    {(childProps) => <BoxedTextAreaElement {...childProps} {...props} />}
  </BoxedInput>
));
